export default __webpack_public_path__ + "static/Graphik-Semibold-Web-3346a17cf0db815c93f3e8b1cf603fae.eot";